/* @flow */
import dayjs from 'dayjs';

import l from './localization';


export const recurringTextDescription = (interval: RecurringInterval, nextOccurrence: Date) => {
  const day = dayjs(nextOccurrence);

  return interval === 'week' ? ` ${l.every} ${day.format('dddd')} `
    : interval === 'day' ? ` ${day.format('LT')} ${l.recurring_day} `
      : interval === 'year' ? ` ${day.format('MMM Do')} ${l.everyYear} `
        : interval === 'month' ? ` ${day.format('Do')} ${l.everyMonth} `
          : ` ${l[`recurring_${interval}`]} `;
};

export default recurringTextDescription;
